
export class SchoolGetRequest {
  ReferenceId:string;
  SchoolType:number;
  FantasyName:string;
  TenantId:string;
  Page:number
  PageSize:number;
  OrderByProperty:string;
  OrderByDirection:string;
  Cnpj:string;
}
